{
  "controls": {
    "back": "Назад",
    "close": "Закрыть",
    "last": "Готово",
    "next": "Далее",
    "skip": "Пропустить тур"
  },
  "dashboard": {
    "greeting": {
      "title": "Добро пожаловать на дашборд",
      "body": "Это ваша главная страница — быстрый обзор возможностей, снайпов и ваших топовых миров."
    },
    "kpi": {
      "title": "Активные возможности",
      "body": "Сколько прибыльных флипов доступно прямо сейчас по всем вашим инструментам."
    },
    "topOpportunities": {
      "title": "Лучшие возможности",
      "body": "Живой превью лучших флипов. Переключайте вкладки, чтобы видеть быстро продающиеся товары или лучшие покупки."
    },
    "snipeAlerts": {
      "title": "Недавние снайпы",
      "body": "Срабатывания снайп-алертов за последний цикл обновления. Нажмите, чтобы настроить новые алерты."
    },
    "realmStats": {
      "title": "Топ-миры",
      "body": "Ваши сильнейшие миры для продажи, отсортированные по населению, аукционам или отношению цен."
    },
    "quickActions": {
      "title": "Быстрый доступ",
      "body": "Переходите отсюда напрямую в любой инструмент."
    }
  },
  "flipping": {
    "dataFreshness": {
      "title": "Статус данных",
      "body": "Показывает, насколько свежи данные аукциона. Страница обновляется сама, когда приходят новые данные."
    },
    "filters": {
      "title": "Панель фильтров",
      "body": "Фильтруйте по миру, качеству, прибыли, скорости продаж и другому. Сохраняйте любимые сочетания как пресеты."
    },
    "stats": {
      "title": "Сводка инвестиций",
      "body": "Итоги по видимым флипам: нужная вложение, ожидаемая выручка и прибыль с учётом комиссии аукциона."
    },
    "table": {
      "title": "Возможности",
      "body": "Каждая строка — флип: купить в одном мире, продать в другом. Кликните по предмету, чтобы скопировать или добавить в избранное."
    },
    "pagination": {
      "title": "Постраничная навигация",
      "body": "Переключайте страницы результатов и выбирайте, сколько предметов показывать за раз."
    }
  },
  "housing": {
    "dataFreshness": {
      "title": "Статус данных",
      "body": "Показывает, насколько свежи данные housing-аукциона и когда ожидается следующее обновление."
    },
    "filters": {
      "title": "Панель фильтров",
      "body": "Фильтруйте housing-флипы по миру, прибыли, скорости продаж и потолку выкупа."
    },
    "stats": {
      "title": "Сводка инвестиций",
      "body": "Итоги по видимым housing-флипам — удобно для оценки бюджета перед покупкой."
    },
    "table": {
      "title": "Housing-возможности",
      "body": "Каждая строка — housing-предмет, который дёшев в одном мире и стоит дороже в другом."
    },
    "pagination": {
      "title": "Постраничная навигация",
      "body": "Переключайте страницы и регулируйте число показываемых результатов."
    }
  },
  "dropship": {
    "dataFreshness": {
      "title": "Статус данных",
      "body": "Показывает, насколько свежи данные dropship и когда придёт следующее обновление."
    },
    "filters": {
      "title": "Панель фильтров",
      "body": "Фильтруйте возможности dropship по миру, качеству, дополнению и прибыльности."
    },
    "stats": {
      "title": "Сводка инвестиций",
      "body": "Итоги по видимым dropship-сделкам — полезно для планирования капитала и нагрузки."
    },
    "table": {
      "title": "Dropship-возможности",
      "body": "Каждая строка — предмет, который выгодно купить в одном мире и перепродать в другом."
    },
    "pagination": {
      "title": "Постраничная навигация",
      "body": "Переключайте страницы с результатами dropship."
    }
  },
  "inventory": {
    "realms": {
      "title": "Миры для продажи",
      "body": "Выберите миры, относительно которых хотите проанализировать инвентарь."
    },
    "csv": {
      "title": "Вставьте инвентарь",
      "body": "Вставьте сюда CSV вашего запаса с разделителем точка с запятой — инструмент найдёт прибыльные межсерверные сделки."
    },
    "analyze": {
      "title": "Анализ",
      "body": "Запустите межсерверный анализ для только что вставленного инвентаря."
    },
    "results": {
      "title": "Рекомендации по флипам",
      "body": "Каждая строка — предмет из вашего инвентаря, который сейчас стоит дороже в другом мире."
    },
    "export": {
      "title": "Экспорт",
      "body": "Скачайте анализ в CSV для использования в таблице или аддоне."
    }
  },
  "stats": {
    "table": {
      "title": "Статистика миров",
      "body": "Сравнивайте аукционные цены, число лотов и тренды по всем мирам вашего региона."
    }
  },
  "tsm": {
    "filters": {
      "title": "Фильтры",
      "body": "Выберите, какие предметы включать по категории, дополнению, качеству и прибыли."
    },
    "table": {
      "title": "Список предметов",
      "body": "Предметы, подходящие под ваши фильтры — копируйте напрямую в операцию TSM Price Source."
    },
    "pagination": {
      "title": "Постраничная навигация",
      "body": "Переключайте страницы и выбирайте, сколько предметов показывать за раз."
    }
  },
  "snipe": {
    "tabs": {
      "title": "Категории алертов",
      "body": "Переключайтесь между снайпами предметов, питомцев, токеном WoW и правилами по уровню предмета."
    },
    "add": {
      "title": "Добавить новый алерт",
      "body": "Добавьте предмет, питомца или правило в список — вы получите уведомление, как только цена упадёт ниже целевой."
    },
    "list": {
      "title": "Активные алерты",
      "body": "Ваши настроенные алерты с целевыми ценами и назначенными webhook-каналами."
    },
    "import": {
      "title": "Массовый импорт",
      "body": "Импортируйте весь список сразу: нажмите «Импорт», чтобы выбрать файл, или просто вставьте скопированный список в любом месте этой страницы. Перед сохранением вы увидите предпросмотр импорта."
    },
    "inlineEdit": {
      "title": "Редактируйте цены на месте",
      "body": "Нажмите на любую цену в таблице, чтобы изменить её прямо там — Enter сохраняет, Esc отменяет. Удалённые оповещения можно вернуть кнопкой «Отменить», а список можно сортировать по названию или цене."
    }
  },
  "tsmProfile": {
    "video": {
      "title": "Видео по настройке",
      "body": "Посмотрите короткое видео с полным руководством по настройке профиля TSM."
    },
    "min": {
      "title": "Минимальная цена",
      "body": "Скопируйте эту формулу в операцию TSM минимальной цены."
    },
    "max": {
      "title": "Максимальная цена",
      "body": "Скопируйте эту формулу в операцию TSM максимальной цены."
    },
    "normal": {
      "title": "Обычная цена",
      "body": "Скопируйте эту формулу в операцию TSM обычной цены."
    }
  },
  "settingsRealm": {
    "region": {
      "title": "Регион",
      "body": "Выберите US или EU — это определяет все списки миров в приложении."
    },
    "buying": {
      "title": "Миры для покупки",
      "body": "Миры, где вы покупаете дёшево. Добавьте столько, сколько сможете комфортно посещать."
    },
    "selling": {
      "title": "Миры для продажи",
      "body": "Миры, где вы перепродаёте с прибылью. Они отображаются как цель во всех инструментах."
    },
    "accounts": {
      "title": "Аккаунты WoW",
      "body": "Если у вас несколько аккаунтов, зарегистрируйте их здесь и распределите по ним миры."
    },
    "save": {
      "title": "Сохранить настройки",
      "body": "Сохраните — остальная часть приложения сразу начнёт использовать эти миры."
    }
  },
  "settingsPersonal": {
    "preview": {
      "title": "Превью фильтров",
      "body": "Живое превью интерфейса фильтров, который вы видите во всех инструментах флиппинга."
    },
    "ranges": {
      "title": "Диапазоны по умолчанию",
      "body": "Задайте диапазоны прибыли, скорости продаж и цен, которые должны применяться сразу в каждом инструменте."
    },
    "dashboard": {
      "title": "Пороги дашборда",
      "body": "Управляйте мин. и макс. ценой выкупа для возможностей, показываемых на дашборде."
    },
    "matching": {
      "title": "Сопоставление предметов",
      "body": "Ограничьте сопоставление статов предмета определёнными дополнениями для точных межсерверных цен."
    },
    "save": {
      "title": "Сохранить умолчания",
      "body": "Сохраните эти настройки как ваши личные значения по умолчанию для всех инструментов."
    }
  },
  "rowActions": {
    "title": "Меню действий со строкой",
    "body": "Первая колонка теперь объединяет звезду избранного, флажок выбора и колокольчик оповещений снайпа. Открой это меню, чтобы выбрать или снять выбор с текущей страницы или со всех страниц, оставить только избранное, либо закрепить вверху избранное, цели снайпа и выбранные строки. Настройки колонок (перетаскивание для изменения порядка и показ/скрытие) тоже находятся здесь."
  },
  "settingsDiscord": {
    "link": {
      "title": "Привязать Discord",
      "body": "Подключите аккаунт Discord, чтобы бот мог присылать алерты и уведомления."
    },
    "verification": {
      "title": "Проверка ЛС",
      "body": "Получите 6-значный код, чтобы убедиться, что бот может писать вам в ЛС."
    },
    "notifications": {
      "title": "Настройки уведомлений",
      "body": "Включите ЛС-уведомления о региональных обновлениях и других событиях."
    },
    "webhooks": {
      "title": "Категории вебхуков",
      "body": "Создавайте категории вебхуков, чтобы направлять снайп-алерты в нужные каналы Discord."
    }
  },
  "classicDeals": {
    "controls": {
      "title": "Classic Deals",
      "body": "Pick your region and realms, then find same-realm undercut opportunities."
    },
    "table": {
      "title": "Deals",
      "body": "Each row is an item you can buy at the lowest price and relist just under the next-cheapest listing on the same realm."
    }
  },
  "filterMode": {
    "title": "Фильтровать или пересчитать",
    "body": "Выберите, что происходит при изменении фильтра: «Фильтровать» мгновенно сужает уже загруженные результаты, а «Пересчитать» запрашивает свежие результаты с сервера."
  }
}
